<template>
  <v-card class="mx-auto mb-15" @click.native="goTo(post.buttonLink)">
    <v-img :src="post.imageUrl" />
  </v-card>
</template>

<script>
export default {
  name: 'postImage',
  props: [
    'post'
  ],
  methods: {
    goTo(link) {
      window.open(link, '_blank');
    },
  }
}
</script>